import type { Plan } from './plans';
import { networkOf } from './planNetwork';

const collator = new Intl.Collator(undefined, { numeric: true });

// Where a plan sits in the list: the ones customers are shown, then
// Community Fibre, then everything else.
const group = (plan: Plan): number => {
  if (plan.published) return 0;
  return networkOf(plan) === 'communityfibre' ? 1 : 2;
};

/** The plans in the order the list shows them, by id within each group. */
export const inListOrder = (plans: ReadonlyArray<Plan>): Plan[] => (
  [...plans].sort((a, b) => group(a) - group(b) || collator.compare(a.id, b.id))
);
